<!-- <div class="flex flex-wrap">
  <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
    <app-card-line-chart></app-card-line-chart>
  </div>
  <div class="w-full xl:w-4/12 px-4">
    <app-card-bar-chart></app-card-bar-chart>
  </div>
</div>
<div class="flex flex-wrap mt-4">
  <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
    <app-card-page-visits></app-card-page-visits>
  </div>
  <div class="w-full xl:w-4/12 px-4">
    <app-card-social-traffic></app-card-social-traffic>
  </div>
</div> -->
<div class="rtl flex flex-wrap">
  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-lightBlue-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            موجودی فعلی
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/Wallet_outline.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData?.walletAmount| number:''}}
          تومان </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-yellow-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            کل تراکنشات
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/wallet-money.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
          <i class="fa fa-user" ></i>
          statPercent%
        </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData?.allWalletAmount| number:''}}
          تومان </span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-emerald-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            ویزیت های پیش رو
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/message-time.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData?.upComingVisits}} ویزیت</span>
      </p>
    </div>
  </div>

  <div class="w-full lg:w-3/12 xl:w-3/12 p-4">
    <div class="flex-auto p-4 bg-teal-500 rounded shadow-lg">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-100 uppercase font-bold text-xs">
            <!-- statSubtitle -->
          </h5>
          <span class="font-semibold text-lg text-white">
            کل ویزیت ها
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full">
            <img src="../../../../assets/img/icon/menu-board.svg" alt="">
          </div>
        </div>
      </div>
      <p class="text-sm text-blueGray-100 mt-4">
        <!-- <span class="mr-2">
        <i class="fa fa-user" ></i>
        statPercent%
      </span> -->
        <span class="whitespace-nowrap font-semibold text-xl text-white"> {{dashboardData?.visitCount}} ویزیت</span>
      </p>
    </div>
  </div>
</div>


<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0 mt-5">
  <div class="flex-auto p-3">
    <div class="relative w-full overflow-x-auto rounded-md">
      <table class="w-full bg-transparent border-collapse">
        <thead class="bg-primary text-white">
          <tr>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              نوع ویزیت
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              نام بیمار
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              زمان
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              ساعت شروع
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              ساعت پایان
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              وضعیت
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              وضعیت پرداخت
            </th>
            <th class="align-middle border border-solid p-3 text-base border-l-0 border-r-0 font-semibold">
              ورود
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b" *ngFor="let appointment of dashboardData?.visits">
            <td class="border-t-0 align-middle text-sm p-3" >
              {{appointment.type==1?'متنی':appointment.type==2?'تلفنی':appointment.type==3?'تصویری':appointment.type==4?'حضوری':null}}
              </td>
              <td class="border-t-0 align-middle text-sm p-3">
                 {{appointment.userName}}
              </td>
              <td class="border-t-0 align-middle text-sm p-3">
                  {{(appointment.date|shamsiDate)}}
              </td>
              <td class="border-t-0 align-middle text-sm p-3">
                {{convertUTCMinutesToLocal(appointment.startCounter)!='00:00'?convertUTCMinutesToLocal(appointment.startCounter):'---'}}
              </td>
              <td class="border-t-0 align-middle text-sm p-3">
                {{calculateTime(appointment.endCounter)!='00:00'?calculateTime(appointment.endCounter):'---'}}
              </td>
              <td class="border-t-0 align-middle text-sm p-3">
                 {{appointment.status==1?'در انتظار تایید':appointment.status==2?'تایید شده':appointment.status==3?'در حال انجام':appointment.status==4?'انجام شده':appointment.status==5?'کنسل شده':null}}
              </td>
              <!-- <td
                class="border-t-0 align-middle text-sm p-3"
              >
                {{appointment.category}}
              </td> -->
              
              <td class="border-t-0 align-middle text-sm p-3">
                 {{appointment.paymentStatus==1?'در انتظار تایید':appointment.paymentStatus==2?'تایید شده':appointment.paymentStatus==3?'تایید نشده':null}}
              </td>
              
              <td class="border-t-0 align-middle text-sm p-3">
              <button *ngIf="appointment.type==visitType.TextVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
              [routerLink]="['/doctor-panel/chat/'+appointment.id]" [disabled]="appointment.paymentStatus!=2"> ورود </button>
              
              <button *ngIf="appointment.type==visitType.PhoneVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
                [routerLink]="['/doctor-panel/visit-link/'+appointment.id]" [disabled]="isActiveVisitLink(appointment.date, appointment.endCounter)||appointment.paymentStatus!=2"> ورود </button>
              
              <button *ngIf="appointment.type==visitType.VideoVisit" class="bg-primary text-white rounded pb-2 pt-1 px-3 text-sm disabled:cursor-not-allowed disabled:bg-gray-200" type="button" 
              [routerLink]="['/doctor-panel/visit-link/'+appointment.id]" [disabled]="isActiveVisitLink(appointment.date, appointment.endCounter)||appointment.paymentStatus!=2" > ورود </button>
              
              <span *ngIf="appointment.type==visitType.BodyVisit" class="text-sm" > --- </span>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>